import { TransitionError } from '../account';
import { Stages } from '../../types/Stages';

export enum RejectReasons {
  Fraud = 'Fraud',
  FailsAffordability = 'Fails affordability',
  FailsProductCriteria = 'Fails product criteria',
}

export enum WithdrawnReasons {
  CancelledByBroker = 'Cancelled by broker',
  FailsUnderwritingCriteria = 'Fails underwriting criteria',
  FailedRiskChecks = 'Failed risk checks',
  DuplicateApplication = 'Duplicate application',
  AlternativeLender = 'Alternative lender',
  Other = 'Other',
}

export enum ApplicationStatuses {
  WithBroker = 'With Broker',
  WithLender = 'With Lender',
  Withdrawn = 'Withdrawn',
  Rejected = 'Rejected',
  Complete = 'Complete',
}

export enum UnderwritingStatuses {
  Withdrawn = 'Withdrawn',
  Rejected = 'Rejected',
  Complete = 'Complete',
  // status = WithBroker | WithLender
  CreditDecision = 'Credit Decision',
  Affordability = 'Affordability',
  Packaging = 'Packaging',
  Underwriting = 'Underwriting',
  Offer = 'Offer',
  Completion = 'Completion',
}

export enum ApplicationTaskStatus {
  OutstandingForBroker = 'Outstanding for Broker',
  SubmittedToLender = 'Submitted to Lender',
  PendingSubmission = 'Pending submission',
  MoreInformationRequired = 'More Info required',
  Approved = 'Approved',
  ApprovedWithException = 'Approved with exception',
  Rejected = 'Rejected',
}

export type ApplicationTask = {
  stage: Stages;
  status: keyof typeof ApplicationTaskStatus;
  updated: boolean;
  title: string;
  lastUpdated: string;
}

export enum ApplicationChecklistStatus {
  ApplicantToBeCleared = 'Applicant - To be cleared',
  Approved = 'Approved',
  ApprovedAfterOverride = 'Approved after override',
  ApprovedOnReferral = 'Approved on referral',
  AutoApproved = 'Auto-Approved',
  AutoPass = 'Auto pass',
  AwaitingDecision = 'Awaiting Decision',
  Completed = 'Completed',
  DetectedNotOurApplicant = 'Detected (Not our Applicant)',
  NotRequired = 'Not required',
  Overridden = 'Overridden',
  ProceededWithIla = 'Proceeded with ILA',
  Proceeded = 'Proceeded',
  ProceededWithAdditionalSupportRequirements = 'Proceeded with additional support requirements',
  ProceededWithBespokeSecurityCall = 'Proceeded with bespoke security call',
  Referred = 'Referred',
  Rejected = 'Rejected',
}

export type ApplicationChecklist = {
  stage: Stages;
  status: keyof typeof ApplicationChecklistStatus;
  sectionName: string;
}

export type Application = {
  id: string;
  reference: string;
  applicantNames: string[];
  securityAddressPostCode: string;
  underwritingStatus: UnderwritingStatuses | null;
  status: keyof typeof ApplicationStatuses | null;
  rejectionReason: string;
  withdrawalReason: string;
  otherWithdrawalDetail: string;
  brokerageId: string;
  brokerageName: string;
  isCurrentUnderwriter: boolean;
  underwriterAssignedToId: string;
  underwriterAssignedToName: string;
  submissionDate: string;
  slaAmberTrigger: string;
  slaRedTrigger: string;
  lastUpdated: string;
  totalTasksOutstanding: number;
  tasks: ApplicationTask[];
  totalChecklistOutstanding: number;
  checklists: ApplicationChecklist[],
  errors?: Record<string, string[]>,
}

export enum ApplicationStageBackward {
  Packaging = 'Packaging',
  Underwriting = 'Underwriting',
  Offer = 'Offer',
}

export type ChangeStatusOption = {
  key: ApplicationStageBackward,
  value: string,
};

export type ChangeStatusOptions = ChangeStatusOption[];

export type TransitionBackwardResponse = Omit<Application, 'errors'> & {
  reason: {
    errors: TransitionError[] | null;
    warnings: TransitionError[] | null;
  } | null
};
